export default __webpack_public_path__ + "static/mladapobuda_img3-bb9ef7f3c13018022cb9006205e11248.gif";